export enum FilterEnum {
  STRING = 0,
  DATE = 1,
  LIST = 2,
  MULTIPLE_LIST = 3,
  NUMBER = 4
}
